import { getEligibleRoomRates } from 'api/recommendations'

const eligibleRoomRatesByDateRange = new Map<string, Set<string>>()
const eligibleRoomRatesPromises = new Map<string, Promise<Set<string>>>()

function getDateRangeKey(checkIn: string, checkOut: string): string {
  return `${checkIn}|${checkOut}`
}

export function getCachedEligibleRoomRateIds(checkIn: string, checkOut: string): Set<string> | undefined {
  return eligibleRoomRatesByDateRange.get(getDateRangeKey(checkIn, checkOut))
}

export function getEligibleRoomRateIds(checkIn: string, checkOut: string): Promise<Set<string>> {
  const cacheKey = getDateRangeKey(checkIn, checkOut)
  const cachedRoomRates = eligibleRoomRatesByDateRange.get(cacheKey)

  if (cachedRoomRates) {
    return Promise.resolve(cachedRoomRates)
  }

  const existingPromise = eligibleRoomRatesPromises.get(cacheKey)
  if (existingPromise) {
    return existingPromise
  }

  const promise = getEligibleRoomRates(checkIn, checkOut)
    .then(roomRateIds => {
      const roomRateIdSet = new Set(roomRateIds)
      eligibleRoomRatesByDateRange.set(cacheKey, roomRateIdSet)
      return roomRateIdSet
    })
    .catch((error) => {
      eligibleRoomRatesPromises.delete(cacheKey)
      throw error
    })

  eligibleRoomRatesPromises.set(cacheKey, promise)
  return promise
}

export function resetEligibleRoomRatesCache(): void {
  eligibleRoomRatesByDateRange.clear()
  eligibleRoomRatesPromises.clear()
}
